import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import style from '../css/Invoice.module.css';
import Navbar from '../navigation/Navbar';

function Invoice() {
	const { orderNumber } = useParams();
	const [invoices, setInvoices] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const fetchInvoices = async () => {
			try {
				const response = await fetch(
					`https://hometech-repairs.in/homeTech/FetchInvoice.php?booking_id=${orderNumber}`
				);
				const data = await response.json();
				if (data.status) {
					setInvoices(data.data);
				} else {
					setInvoices([]);
				}
			} catch (error) {
				console.error('Error fetching invoice:', error);
			} finally {
				setLoading(false);
			}
		};

		fetchInvoices();
	}, [orderNumber]);

	const downloadPDF = () => {
		const invoiceElement = document.getElementById('invoice');
		html2canvas(invoiceElement).then((canvas) => {
			const imgData = canvas.toDataURL('image/png');
			const pdf = new jsPDF('p', 'mm', 'a4');
			const imgWidth = 190;
			const imgHeight = (canvas.height * imgWidth) / canvas.width;
			pdf.addImage(imgData, 'PNG', 10, 10, imgWidth, imgHeight);
			pdf.save(`Invoice_${orderNumber}.pdf`);
		});
	};

	if (loading) return <p>Loading...</p>;
	if (invoices.length === 0) return <p>No invoices found.</p>;

	const totalAmount = invoices.reduce(
		(sum, invoice) => sum + parseFloat(invoice.amount),
		0
	);

	return (
		<div>
			{/* <Navbar /> */}
			<div className={style.container}>
				<div id="invoice">
					<h2 className={style.heading}>Invoice Details - {orderNumber}</h2>
					<table>
						<thead>
							<tr className={style.header}>
								<th className={style.title}>Date</th>
								<th className={style.title}>Description</th>
								<th className={style.title}>Quantity</th>
								<th className={style.title}>Amount</th>
								<th className={style.title}>Payment Method</th>
								<th className={style.title}>Payment Status</th>
							</tr>
						</thead>
						<tbody>
							{invoices.map((invoice, index) => (
								<tr key={index}>
									<td className={style.text}>{invoice.date}</td>
									<td className={style.text}>{invoice.description}</td>
									<td className={style.text}>{invoice.qty}</td>
									<td className={style.text}>₹{invoice.amount}</td>
									<td className={style.text}>{invoice.payment_method}</td>
									<td className={style.text}>{invoice.payment_status}</td>
								</tr>
							))}
						</tbody>
					</table>
					<div className={style.amount_box}>
						<p className={style.totalAmount}>
							Total Amount: ₹{totalAmount.toFixed(2)}
						</p>
					</div>
				</div>

				<button onClick={downloadPDF} className={style.downloadButton}>
					Download PDF
				</button>
			</div>
		</div>
	);
}

export default Invoice;
